import isLeadTimeExpired from '@/utils/is-lead-time-expired';
import { parseSafeDate } from '@/utils/parse-safe-date';
import setTime from '@/utils/setTime';

export type LeadTimeListingInput = {
  booking_lead_time?: number | null;
  check_in_time?: string | null;
};

export const LEAD_TIME_CALL_TO_BOOK_MESSAGE =
  'Please call to book for last minute reservations.';

export const mustCallToBookForListing = (
  checkInDate: string | undefined,
  listing: LeadTimeListingInput | null | undefined,
  brandTimezone: string
): boolean => {
  const parsedCheckIn = parseSafeDate(checkInDate);

  if (!parsedCheckIn || !listing) {
    return false;
  }

  return isLeadTimeExpired(
    setTime(parsedCheckIn, listing.check_in_time || '16:00'),
    listing.booking_lead_time || 0,
    brandTimezone
  );
};
